var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -9.5,
    width: 90,
    height: 90
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_3055_9653_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 70,
    height: 70,
    rx: 17.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0571 44.4395C25.5367 43.9185 25.5372 43.0742 26.0581 42.5537L33.1128 35.5049L26.0894 28.4707C25.5692 27.9496 25.5703 27.1052 26.0913 26.585C26.6124 26.0648 27.4568 26.0659 27.9771 26.5869L34.9995 33.6201L42.0425 26.583C42.5633 26.0626 43.4077 26.0633 43.9282 26.584C44.4487 27.1049 44.4482 27.9493 43.9272 28.4697L36.8833 35.5078L43.9272 42.5605C44.4474 43.0816 44.4463 43.926 43.9253 44.4463C43.4042 44.9663 42.5598 44.9653 42.0396 44.4443L34.9966 37.3926L27.9429 44.4404C27.4219 44.9609 26.5776 44.9604 26.0571 44.4395Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3055_9653_clip_path",
    transform: "translate(10 9.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 70,
    height: 70,
    rx: 17.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaClose);
export default __webpack_public_path__ + "static/media/aa-close.2b4b1d06f763258b6e5436c05fa2fd46.svg";
export { ForwardRef as ReactComponent };